// extracted by mini-css-extract-plugin
export default {"input":"MyInput_input__Qqtdl"};